import React, { FC, ReactNode } from 'react';
import { MessageDialog } from 'src/components/widgets/dialog';
import { Spinner } from 'src/components/widgets/spinner';
import { Center } from 'src/shared/globals';
import { SwitchWizardStep, SwitchWizardStepIndicator } from './switchWizardSteps';

const TITLE_STYLE = { marginTop: '20px', textAlign: 'center' } as const;
const NOTE_STYLE = { textAlign: 'center', fontSize: '14px', color: '#666' } as const;

interface SwitchProgressDialogProps {
    /** The headline under the spinner. */
    title: ReactNode;
    note: ReactNode;
    /** Second note line — only some call sites have one, so it stays an explicit slot rather than a list. */
    secondaryNote?: ReactNode;
    showCloseButton: boolean;
    /** Which wizard stage this spinner belongs to. When set, the shared step indicator is shown above the spinner. */
    step?: SwitchWizardStep;
}

/**
 * The spinner-plus-note shell used by every long-running step of the switch flow.
 *
 * `note` and `secondaryNote` are positional slots rather than an array on purpose: an array would need keys,
 * turning static children into a keyed list and changing how React reconciles the dialog.
 */
const SwitchProgressDialog: FC<SwitchProgressDialogProps> = ({ title, note, secondaryNote, showCloseButton, step }) => (
    <MessageDialog
        showCloseButton={showCloseButton}
        titleHtml={step !== undefined ? <SwitchWizardStepIndicator step={step} /> : undefined}
        message={
            <>
                <Center>
                    <Spinner />
                </Center>
                <p style={TITLE_STYLE}>{title}</p>
                <p style={NOTE_STYLE}>{note}</p>
                {secondaryNote !== undefined && <p style={NOTE_STYLE}>{secondaryNote}</p>}
            </>
        }
        buttons={[]}
    />
);

export default SwitchProgressDialog;
